import React from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";

const Alert = React.forwardRef(function Alert(props, ref) {
  return (
    <MuiAlert
      elevation = {6}
      ref = {ref}
      variant = "filled"
      {...props}
    />
  );
});

export default function ToastMessages(props) {
  return (
    <Snackbar
      anchorOrigin = {{horizontal: "center", vertical: "top"}}
      autoHideDuration = {4000}
      onClose = {props.close}
      open = {props.open}
    >
      <Alert
        onClose = {props.close}
        severity = {props.severity}
        sx = {{width: "100%"}}
      >
        {props.messages}
      </Alert>
    </Snackbar>
  );
};
